import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { postponeDto } from "../types/api/api-types";
import { axiosApi } from "./axios";
import { toast } from "react-toastify";

const postponePublic = async (data: { id: string; payload: postponeDto }) => {
  return axiosApi.post(`/postpone/public/${data.id}`, data.payload);
};

export const usePostponePublic = () => {
  return useMutation({
    mutationFn: postponePublic,
    onSuccess: () => {},
    onError: () => {},
  });
};

const postpone = async (data: { id: string; payload: postponeDto }) => {
  return axiosApi.post(`/postpone/${data.id}`, data.payload);
};

export const usePostpone = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postpone,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["expedition", "all"] });
      toast.success("Enlèvement reporté");
    },
    onError: () => {
      toast.error("Erreur lors du report de l'enlèvement");
    },
  });
};

const getAvailablePickupSlots = async (id: string) => {
  return axiosApi.get(`/postpone/available-slots/${id}`).then((res) => res.data);
};

export const useGetAvailablePickupSlots = (id: string) => {
  return useQuery({
    queryKey: ["pickupZones"],
    queryFn: () => getAvailablePickupSlots(id),
    enabled: true,
  });
};
